// extracted by mini-css-extract-plugin
export default {"button":"DontHaveGarudaAccountButton_button__XgmXI","buttonText":"DontHaveGarudaAccountButton_buttonText__3FNcZ"};